import { render, staticRenderFns } from "./TianyiManagement.vue?vue&type=template&id=61c979b8&scoped=true"
import script from "./TianyiManagement.vue?vue&type=script&lang=js"
export * from "./TianyiManagement.vue?vue&type=script&lang=js"
import style0 from "./TianyiManagement.vue?vue&type=style&index=0&id=61c979b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c979b8",
  null
  
)

export default component.exports